export default "__VITE_ASSET__CjHMZHuu__"